<template>
  <div class="lucky-wheel">
    <div class="wheel-pointer" @click="handleStart()"></div>
    <div class="wheel-bg" :style="rotateStyle">
      <canvas width=200 height=200 id="wheelCanvas"></canvas>
      <div class="prize-list">
        <div
          class="prize-item"
          v-for="(item,index) in prizeList"
          :key="index"
          :style="item.style"
        >
          <div class="prize-type">{{item.name}}</div>
          <div class="prize-pic">
            <img :src="item.icon" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const CIRCLE_ANGLE = 360
const config = {
  // 总旋转时间
  duration: 6000,
  // 旋转圈数
  circle: 8,
  mode: 'cubic-bezier(0.45,0.1,0.05,1)'
}
export default {
  name: 'LuckyWheel',
  props: {
    prizeList:{
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      config,
      index: 0, // 选中的物品
      angleList: [],
      rotateAngle: 0, // 旋转角度
      isRotating: false // 是否旋转
    };
  },
  watch: {
    prizeList() {
      this.formatPrizeList(this.prizeList)
      this.drawCanvas()
    }
  },
  computed: {
    rotateStyle () {
      return `
        -webkit-transition: transform ${this.config.duration}ms ${this.config.mode};
        transition: transform ${this.config.duration}ms ${this.config.mode};
        -webkit-transform: rotate(${this.rotateAngle}deg);
            transform: rotate(${this.rotateAngle}deg);`
    }
  },
  created() {
    this.formatPrizeList(this.prizeList);
  },
  mounted() {
    this.drawCanvas()
  },
  methods: {
    // 格式化奖品列表，计算每个奖品的位置
    formatPrizeList (list) {
      // 记录每个奖的位置
      const angleList = []
      const l = list.length
      // 计算单个奖项所占的角度
      const average = CIRCLE_ANGLE / l
      const half = average / 2
      // 循环计算给每个奖项添加style属性
      list.forEach((item, i) => {
        // 每个奖项旋转的位置为 当前 i * 平均值 + 平均值 / 2
        const angle = -((i * average) + half)
        // 增加 style
        item.style = `-webkit-transform: rotate(${angle}deg);
                    transform: rotate(${angle}deg);`
        // 记录每个奖项的角度范围
        angleList.push((i * average) + half )
      })
      this.angleList = angleList
    },
    handleStart(){
      if (this.isRotating) return
      this.$emit('start')
    },
    beginRotate(prize) {
      // prize 奖品列表的下标
      this.index = prize
      // 开始旋转
      this.rotating()
    },
    rotating() {
      const { isRotating, angleList, config, rotateAngle, index } = this
      if (isRotating) return
      this.isRotating = true
      // 计算角度
      const angle =
        // 初始角度
        rotateAngle +
        // 多旋转的圈数
        config.circle * CIRCLE_ANGLE +
        // 奖项的角度
        angleList[index] -
        (rotateAngle % CIRCLE_ANGLE)

      this.rotateAngle = angle
      // 旋转结束后，允许再次触发
      setTimeout(() => {
        this.rotateOver()
      }, config.duration + 1000)
    },
    rotateOver () {
      this.isRotating = false
      this.$emit('end', this.index)
    },
    drawCanvas() {
      //获取canvas画布
      var canvas = document.getElementById("wheelCanvas");
      var ctx = canvas.getContext("2d");
      var canvasW = canvas.width; // 画板的高度
      var canvasH = canvas.height; // 画板的宽度
      //计算每个奖项所占角度数
      var number = this.prizeList.length
      var baseAngle = Math.PI * 2 / number;
      ctx.clearRect(0,0,canvasW,canvasH);//去掉背景默认的黑色

      var colors = ["#FFD527","#FFF68B"];
      var startAngle = - 0.5 * Math.PI
      for(var index = 0; index < number; index++) {
          var angle = index * baseAngle + startAngle;
          var color = colors[index%2];//设置每个扇形区域的颜色
          ctx.strokeStyle = color; //设置画图线的颜色
          ctx.fillStyle = color
          ctx.beginPath();//开始绘制
          ctx.arc(canvasW * 0.5, canvasH * 0.5, (canvasW * 0.5 - 10), angle, angle + baseAngle, false);
          ctx.arc(canvasW * 0.5, canvasH * 0.5, 0, angle + baseAngle, angle, true);
          //context.arc(x,y,r,sAngle,eAngle,counterclockwise);创建弧/曲线
          ctx.stroke();//开始链线
          ctx.fill();//填充颜色
          ctx.save();//保存当前环境的状态
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.lucky-wheel {
  margin: 0 auto;
  position: relative;
  width: 295px;
  height: 295px;
  #wheelCanvas, .wheel-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("~@/assets/draw_wheel.png") no-repeat center top;
    background-size: 100%;
    color: rgb(255, 93, 93);
  }
  .wheel-pointer {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    width: 100px;
    height: 100px;
    background: url("~@/assets/draw_btn.png") no-repeat center top;
    background-size: 100%;
    transform: translate3d(-50%, -50%, 0);
  }
  .wheel-bg div {
    text-align: center;
  }
  .prize-list {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .prize-list .prize-item {
    position: absolute;
    width: 115px;
    height: 150px;
    top: 0;
    left: 50%;
    margin-left: -57.5px;
    transform-origin: 50% 100%;
  }
  .prize-pic img {
    width: 42px;
    margin-top: 8px;
  }
  .prize-type {
    font-size: 16px;
    margin-top: 29px;
  }
}
</style>
